<template>
  <progress-countdown-display
    :time="time"
    :time-left="timeLeft"
  ></progress-countdown-display>
</template>

<script>
import ProgressCountdownDisplay from "./ProgressCountdownDisplay";

export default {
  name: "progress-countdown",
  components: {
    ProgressCountdownDisplay,
  },
  props: {
    name: {
      type: String,
    },
    time: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      timeLeft: 0,
      running: false,
      timer: null,
    };
  },
  methods: {
    next() {
      if (this.running) {
        if (this.timeLeft > 0) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.timeLeft = this.timeLeft - 1;
            this.next();
          }, 1000);
          localStorage.setItem("ls_time_" + this.name, this.timeLeft);
          this.$emit("timeStep", this.timeLeft);
        } else {
          this.$emit("timeStep", 0);
          this.$emit("timeover");
        }
      }
    },
    // next() {
    //   if (this.running) {
    //     if (this.timeLeft > 0) {
    //       clearTimeout(this.timer);
    //       this.timer = setTimeout(
    //         function () {
    //           this.timeLeft = this.timeLeft - 1;
    //           this.next();
    //         }.bind(this),
    //         1000
    //       );
    //       localStorage.setItem("ls_time_" + this.name, this.timeLeft);
    //     } else {
    //       this.$emit("timeover");
    //     }
    //   }
    // },

    start() {
      if (this.time > 0) {
        this.running = true;
        this.timeLeft =
          localStorage.getItem("ls_time_" + this.name) || this.time;
        this.next();
      }
    },
    stop() {
      this.clean();
    },
    updateTimer(tl) {
      clearTimeout(this.timer);
      this.timeLeft = tl;
      this.next();
    },
    clean() {
      this.running = false;
      localStorage.removeItem("ls_time_" + this.name);
      clearTimeout(this.timer);
    },
  },
  mounted() {
    this.pb_cont = $(this.$el);
    this.pb = this.pb_cont.find(".bar");
  },
  beforeDestroy() {
    this.clean();
  },
};
</script>
